import { Leaf } from "lucide-react";

const ITEMS = [
  "Monthly Bookkeeping",
  "Financial Reporting",
  "Payroll Oversight",
  "Compensation & Incentives",
  "Business Advisory",
  "Special Projects",
  "Cash Flow Forecasting",
  "QuickBooks Setup & Cleanup",
];

export const Marquee = () => (
  <div className="overflow-hidden border-y border-forest/10 bg-parchment py-6" data-testid="services-marquee">
    <div className="marquee-track flex w-max items-center">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span key={i} className="flex items-center whitespace-nowrap">
          <span className="font-display text-2xl italic text-forest/75 md:text-3xl">{item}</span>
          <Leaf className="mx-10 h-4 w-4 text-gold" strokeWidth={1.5} />
        </span>
      ))}
    </div>
  </div>
);
